module.exports = __webpack_public_path__ + "img/mobile-export.10f201db.svg";